import React from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import LanguageModal from './components/LanguageModal';
import Header from './components/Header';
import Hero from './components/Hero';
import BenefitsStrip from './components/BenefitsStrip';
import WhatWeDo from './components/WhatWeDo';
import Systems from './components/Systems';
import HowWeWork from './components/HowWeWork';
import Projects from './components/Projects';
import CustomSolutions from './components/CustomSolutions';
import About from './components/About';
import ProposalCTA from './components/ProposalCTA';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import SocialFloating from './components/SocialFloating';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <LanguageModal />
        <Header />
        <Hero />
        <BenefitsStrip />
        <WhatWeDo />
        <Systems />
        <HowWeWork />
        <Projects />
        <CustomSolutions />
        <About />
        <ProposalCTA />
        <FinalCTA />
        <Footer />
        <SocialFloating />
      </div>
    </LanguageProvider>
  );
}

export default App;
